export const companiesRoutes = [
  {
    path: '/companies',
    name: 'companies',
    component: () => import('./views/ListCompanies.vue'),
    meta: {
      auth: true,
      layout: 'home',
      requiredRoles: ['superadmin', 'admin'],
    },
  },
  {
    path: '/companies/add',
    name: 'companiesa/add',
    component: () => import('./views/CreateCompany.vue'),
    meta: {
      auth: true,
      layout: 'home',
      requiredRoles: ['superadmin', 'admin'],
    },
  },
]
